import type { ToolId } from '../types'

interface WorkbenchIconProps {
  id: ToolId
  size?: number
}

export function WorkbenchIcon({ id, size = 52 }: WorkbenchIconProps) {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 64 64',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 3,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true,
  }

  if (id === 'compress') return (
    <svg {...common}><rect x="18" y="13" width="28" height="38" rx="3" /><path d="m23 39 7-8 6 6 5-6" /><circle cx="38" cy="23" r="3" /><path d="M7 32h11m-5-5 5 5-5 5M57 32H46m5-5-5 5 5 5" /></svg>
  )
  if (id === 'resize') return (
    <svg {...common}><rect x="15" y="15" width="34" height="34" rx="3" /><path d="M7 23V7h16M7 7l14 14M57 41v16H41m16 0L43 43" /><path d="m21 42 8-9 6 6 7-8" /></svg>
  )
  if (id === 'crop') return (
    <svg {...common}><path d="M19 8v34a4 4 0 0 0 4 4h33M8 19h34a4 4 0 0 1 4 4v33" /><path d="M29 25v10h10" /></svg>
  )
  if (id === 'convert-jpg') return (
    <svg {...common}><path d="M12 16h26l9 9v23H12z" /><path d="M38 16v10h9M18 38h15" /><path d="M38 35h14m-5-5 5 5-5 5" /><circle cx="23" cy="27" r="3" /></svg>
  )
  if (id === 'convert-png') return (
    <svg {...common}><rect x="8" y="13" width="30" height="25" rx="3" /><rect x="26" y="27" width="30" height="24" rx="3" /><path d="m12 34 8-8 7 6 4-4M31 46l7-7 6 5 5-6" /><path d="M43 12h11v11m0-11L42 24" /></svg>
  )
  if (id === 'html-to-image') return (
    <svg {...common}><rect x="7" y="10" width="50" height="44" rx="4" /><path d="M7 20h50M15 15h1m6 0h1" /><path d="m25 29-6 6 6 6m14-12 6 6-6 6m-9 4 5-20" /></svg>
  )
  if (id === 'rotate') return (
    <svg {...common}><rect x="17" y="20" width="30" height="27" rx="3" /><path d="m21 41 8-9 7 7 5-6" /><path d="M18 12a23 23 0 0 1 34 10m0 0V12m0 10H42" /></svg>
  )
  if (id === 'watermark') return (
    <svg {...common}><rect x="9" y="11" width="46" height="36" rx="3" /><path d="m14 41 10-11 8 8 7-9 11 12" /><path d="M23 51h25M28 44v7" /><path d="m38 18 9 8m-9 0 9-8" /></svg>
  )
  if (id === 'editor') return (
    <svg {...common}><path d="M11 17h42M11 32h42M11 47h42" /><circle cx="24" cy="17" r="5" fill="var(--surface)" /><circle cx="42" cy="32" r="5" fill="var(--surface)" /><circle cx="29" cy="47" r="5" fill="var(--surface)" /></svg>
  )
  if (id === 'upscale') return (
    <svg {...common}><rect x="16" y="16" width="32" height="32" rx="3" /><path d="M24 8H8v16M8 8l15 15M40 56h16V40m0 16L41 41" /><path d="m21 42 7-8 6 6 7-9" /></svg>
  )
  if (id === 'remove-bg') return (
    <svg {...common}><path d="M12 12h40v40H12z" strokeDasharray="5 5" /><path d="m20 39 19-20 9 9-19 20H20z" /><path d="m35 23 9 9M31 48h21" /></svg>
  )
  if (id === 'meme') return (
    <svg {...common}><path d="M9 12h46v35H31l-12 8v-8H9z" /><circle cx="22" cy="29" r="2" fill="currentColor" stroke="none" /><circle cx="32" cy="29" r="2" fill="currentColor" stroke="none" /><circle cx="42" cy="29" r="2" fill="currentColor" stroke="none" /></svg>
  )
  return (
    <svg {...common}><path d="M20 9H9v11m35-11h11v11M20 55H9V44m35 11h11V44" /><circle cx="32" cy="32" r="14" strokeDasharray="3 5" /><circle cx="32" cy="32" r="6" opacity=".55" /><path d="M17 32h30" opacity=".35" /></svg>
  )
}
